<template>
  <b-modal
    id="pools-modal"
    size="lg"
    :title="$t('portfolioManager.poolsModal.title')"
    hide-footer
    centered
  >
    <p>{{ $t("portfolioManager.poolsModal.description") }}</p>
    <div
      class="
        pools-list-header
        d-flex
        justify-content-between
        align-items-center
      "
    >
      <span class="body-medium"
        >{{ $t("portfolioManager.poolsModal.pools") }}:</span
      >
      <b-button variant="primary" @click="switchModals">
        <plus-icon /> {{ $t("portfolioManager.poolsModal.createNewPool") }}
      </b-button>
    </div>
    <div class="pools slim-scroll">
      <pool-box v-for="pool in pools" v-bind:key="pool.pool_id" v-bind="pool" />
    </div>
  </b-modal>
</template>

<script>
import PlusIcon from "vue-material-design-icons/PlusCircleOutline.vue";
import PoolBox from "../PoolBox.vue";
import { mapGetters } from "vuex";
export default {
  name: "pools-modal",
  components: {
    PlusIcon,
    PoolBox,
  },
  computed: {
    ...mapGetters("portfolioManagerStore", ["pools"]),
  },
  methods: {
    switchModals() {
      this.$bvModal.hide("pools-modal");
      this.$bvModal.show("create-pool-modal");
    },
  },
};
</script>

<style scoped lang="scss">
.pools-list-header {
  margin-bottom: toRem(22);
  .body-medium {
    font-size: toRem(14);
  }
}
.pools {
  max-height: 70vh;
  overflow-y: scroll;
  padding: 10px 15px;
  margin: -10px -15px;
}
</style>